Ext.define('SA.AcsTable.FolderData', {
    constructor({observable, requestedAttributeIds}) {
        this.requestedAttributeIds = requestedAttributeIds;
        this.observable = observable;
        this.promises = {};
        this.results = {};
    },

    async createPromise({folderId}) {
        var children = await SA.Ajax.request({resource: 'attributes/tree', data: {parent: folderId}}),
            ids = children.filter(child => Reflect.has(child, 'attribute')).map(({attribute}) => attribute);

        this.requestedAttributeIds.addIds(ids);

        return SA.data.AttributesCache.getModelPromise(ids);
    },

    async load({folderId}) {
        if (this.promises[folderId]) {
            return;
        }

        var promise = this.promises[folderId] = this.createPromise({folderId});

        this.results[folderId] = await promise;
        this.observable.fireEvent('results');
    },

    get({folderId}) {
        return this.results[folderId] ?? [];
    }
});